import React, { ChangeEvent } from 'react'
import CardNew from 'presentation/shared/components/CardNew'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'
import TextFieldNew from 'presentation/shared/components/TextFieldNew'
import DividerNew from 'presentation/shared/components/DividerNew'
import { ReactComponent as TrashIcon } from 'presentation/assets/icons/new-trash-green.svg'
import { Material } from 'main/factories/pages/doctor/ambulatory-authorization/ambulatory-authorization-dashboard-factory'
import * as S from './styles'

type MaterialCardProps = {
  material: Material
  handleQuantityChange?: (
    name: string,
    e: ChangeEvent<HTMLInputElement>
  ) => void
  handleQuantityBlur?: (name: string, e: ChangeEvent<HTMLInputElement>) => void
  removeMaterial?: (name: string) => void
}

export const MaterialCard = ({
  material,
  handleQuantityChange,
  handleQuantityBlur,
  removeMaterial
}: MaterialCardProps) => {
  return (
    <CardNew style={{ width: '100%' }} shadow="satin">
      <S.CardHeader>
        <SupportTextNew color="neutral500" size="xsmall" weight="bold">
          {material?.name}
        </SupportTextNew>
        {removeMaterial && (
          <S.TrashContainer onClick={() => removeMaterial(material?.name)}>
            <TrashIcon width="24" height="24" />
          </S.TrashContainer>
        )}
      </S.CardHeader>

      <DividerNew marginTop="8px" marginBottom="16px" />

      <S.CardContent>
        <S.Row>
          <div>
            <TextFieldNew
              label="Quantidade"
              labelSize="xxsmall"
              labelOverlapping
              baselineStyle
              type="number"
              // style={{ width: '80px' }}
              value={material?.quantity}
              onChange={(e) =>
                handleQuantityChange && handleQuantityChange(material?.name, e)
              }
              onBlur={(e) =>
                handleQuantityBlur && handleQuantityBlur(material?.name, e)
              }
              requiredColor="neutral800"
              min={1}
              disabled={!handleQuantityChange}
              inputMode="numeric"
              pattern="[0-9]*"
            />
          </div>
        </S.Row>
      </S.CardContent>
    </CardNew>
  )
}
